import { AnchorButton, Button, ButtonGroup } from "@blueprintjs/core";
import _ from "lodash";
import React from "react";
import { Article, ArticleSource } from "../../../api/schema";
import { DeleteStateHelper } from "../../../components/form/DeleteModal";
import { UpdateStateHelper } from "../../../components/form/InputForm";
import { ParentPrettyRender } from "../../../components/ParentRenderer";
import { TableColumns } from "../../../components/Table";
import { UserLanguage } from "../../../lang/lang";

export const ArticleViewTableColumns = (
  setDeleteModalState: React.Dispatch<React.SetStateAction<DeleteStateHelper>>
): TableColumns<Article> => ({
  id: { label: UserLanguage().data.id },
  matchcode: {
    label: UserLanguage().data.article.matchcode,
  },
  name: { label: UserLanguage().data.name },
  display_name: { label: UserLanguage().data.display_name },
  footprint: { label: UserLanguage().data.footprint.label, key: "name" },
  location: {
    label: UserLanguage().data.location.label,
    render: (i) => ParentPrettyRender(i.location),
  },
  product_group: {
    label: UserLanguage().data.product_group.label,
    key: "name",
    render: (i) => ParentPrettyRender(i.product_group),
  },
  article_category: {
    label: UserLanguage().data.articleCategory.label,
    key: "name",
    translate: UserLanguage().data.article_categories,
  },
  actions: {
    label: UserLanguage().actions.label,
    render: (item) => (
      <ButtonGroup>
        <AnchorButton
          intent="primary"
          icon="zoom-in"
          href={`/articles/${item.id}`}
          target="_blank"
          rel="noreferrer"
        />
        {item.datasheet_url ? (
          <AnchorButton
            intent="primary"
            icon="document"
            href={item.datasheet_url}
            target="_blank"
            rel="noreferrer"
          />
        ) : (
          <Button disabled intent="primary" rightIcon="document" />
        )}
        <Button
          intent="danger"
          rightIcon="delete"
          onClick={() =>
            setDeleteModalState({
              open: true,
              id: item.id,
              prettyPrint: `${UserLanguage().data.name}: ${item.name}`,
            })
          }
        />
      </ButtonGroup>
    ),
  },
});

export const PartSourceViewTableColumns = (
  setUpdatePartSourceState: React.Dispatch<
    React.SetStateAction<UpdateStateHelper<ArticleSource>>
  >,
  setDeleteModalSourceState: React.Dispatch<
    React.SetStateAction<DeleteStateHelper>
  >
): TableColumns<ArticleSource> => ({
  order_number: {
    label: UserLanguage().data.articleSource.order_number,
    render: (item) => {
      if (item.url) {
        return (
          <a href={item.url} target="_blank" rel="noreferrer">
            {item.order_number}
          </a>
        );
      } else if (item.distributor.search_url) {
        return (
          <a
            href={item.distributor.search_url.replace("%s", item.order_number)}
            target="_blank"
            rel="noreferrer"
          >
            {item.order_number}
          </a>
        );
      }
      return item.order_number;
    },
  },
  distributor: { label: UserLanguage().data.distributor.label, key: "name" },
  moq: { label: UserLanguage().data.articleSource.moq },
  quantity_scale: {
    label: UserLanguage().data.quantity_scale.label,
    render: (item) =>
      _.map(item.quantity_scale, (qs, i) => (
        <div key={item.id + "_" + i}>
          {qs.quantity}: {qs.price.toFixed(4)}€
        </div>
      )),
  },
  actions: {
    label: UserLanguage().actions.label,
    render: (item) => (
      <ButtonGroup vertical>
        <Button
          intent="primary"
          rightIcon="edit"
          onClick={() =>
            setUpdatePartSourceState({
              open: true,
              item,
            })
          }
        />
        <Button
          intent="danger"
          rightIcon="delete"
          onClick={() =>
            setDeleteModalSourceState({
              open: true,
              id: item.id,
              prettyPrint: `${UserLanguage().data.name}: ${item.order_number}`,
            })
          }
        />
      </ButtonGroup>
    ),
  },
});
